export default "__VITE_ASSET__xeQ6csDz__"